import React from 'react';
import '../template-file-css/document-file-template.css';


export const CBS_LocusScoreSheet = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='CBS_LocusScoreSheet' className='file-pdf-document'>
            <div className='file-template'>

                <p>
                    <center><h3>LOCUS SCORE SHEET</h3></center>
                    
                </p>

                <table>

                    <tr>
                        <td className='w-450'> <span className='eleHeader'>DIMENSIONS</span> </td>
                        <td className='w-150'> <span className='eleHeader'>CURRENT</span> </td>
                        <td className='w-150'> <span className='eleHeader'>CRITERIA</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> I RISK OF HARM: </td> 
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtDimensions_1' name='txtDimensions_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCurrent_1' name='txtCurrent_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCriteria_1' name='txtCriteria_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> II FUNCTIONAL STATUS: </td> 
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtDimensions_2' name='txtDimensions_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCurrent_2' name='txtCurrent_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCriteria_2' name='txtCriteria_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> III MEDICAL, ADDICTIVE, PSYCHIATRIC CO-MORBIDITY: </td> 
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtDimensions_3' name='txtDimensions_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCurrent_3' name='txtCurrent_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCriteria_3' name='txtCriteria_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> IV-A RECOVERY ENVIRONMENT (STRESS): </td> 
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtDimensions_4' name='txtDimensions_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCurrent_4' name='txtCurrent_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCriteria_4' name='txtCriteria_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> IV-B RECOVERY ENVIRONMENT (SUPPORT): </td> 
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtDimensions_5' name='txtDimensions_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCurrent_5' name='txtCurrent_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCriteria_5' name='txtCriteria_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> V RESILIENCY AND TREATMENT: </td> 
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtDimensions_6' name='txtDimensions_6' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCurrent_6' name='txtCurrent_6' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCriteria_6' name='txtCriteria_6' className='add-only' /> </td>
                    </tr> 
                    <tr>
                        <td className='w-750'> VI ENGAGEMENT: </td> 
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtDimensions_7' name='txtDimensions_7' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCurrent_7' name='txtCurrent_7' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCriteria_7' name='txtCriteria_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <b>COMPOSITE SCORE:</b> </td>
                        <td className='w-150'> <input type='text' id='txtCompositeScoreCurrent' name='txtCompositeScoreCurrent' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCompositeScoreCriteria' name='txtCompositeScoreCriteria' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <b>INDEPENDENT CRITERIA (check one):</b> </td>
                        <td className='w-150'>  <input type='radio' id='rbIndependentCrteria_Yes' name='rbIndependentCrteria' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-150'>  <input type='radio' id='rbIndependentCrteria_No' name='rbIndependentCrteria' className='add-only' value='No' /> No </td> 
                    </tr>
                    <tr>
                        <td className='w-450'> <b>LEVEL OF CARE RECOMMENDED:</b> </td>
                        <td className='w-300'> <input type='text' id='txtLevelOfCareRecommend' name='txtLevelOfCareRecommend' className='add-only'  /> </td> 
                    </tr>
                </table> 
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> LMHP SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table> 
            </div>
        </form>

    )
}











